import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { addProductPost } from "../repositories/storeRep";




const initialState = {
  response: {},
  loading: false,
  error: false,
  errorMsg: "",
};
export const addProductData= createAsyncThunk(
  "addProduct",
  async (data, thunkAPI) => {
    const response = await addProductPost(data);
    return response;
  }
);
export const addProductSlice = createSlice({
  name: "addProduct",
  initialState,
  extraReducers: {
    [addProductData.pending]: (state) => {
      state.loading = true;
    },
    [addProductData.fulfilled]: (state, action) => {
      state.loading = false;

      state.response = action.payload;
      console.log(action.payload);
    },
    [addProductData.rejected]: (state, action) => {
      state.loading = false;
      state.error = true;
      state.errorMsg = action.error.message;
      console.log(action.error);
    },
  },
  reducers: {},
});

export default addProductSlice.reducer;
